// The words for what NotesAI found when it checked an unsure outcome itself, shared by the steps under
// a result (AgentChat) and the cards (CardItem), so both say it the same way, and as the server does.
//
// - sourceName(code): where a check looked (check.source), by name; null for no source or an unknown
//   one.
// - reasonWords(code): why a check couldn't confirm it (check.reason, a value-free code). REASON_WORDS
//   is backend/api/agents/checks.py's REASON_WORDS word for word, and reasonWords() is its
//   reason_words(): a missing or unknown code reads as no_lookup's words. Change the two together.
//
// Maps rather than objects: a code called "constructor" is not one.
export const SOURCES = new Map([
  ['app', 'the app'],
  ['twilio', 'Twilio'],
  ['srfax', 'SRFax'],
  ['email', 'the email service'],
]);

export const REASON_WORDS = new Map([
  ['no_lookup', "it can't be looked up"],
  ['gave_up', 'repeated checks over an hour or more found nothing either way'],
  ['unclear', "the app's records don't show either way"],
  ['several', 'several faxes to that number were found'],
  ['not_in_sent', "it wasn't found among the sent emails"],
]);

export const sourceName = (code) => SOURCES.get(code) || null;
export const reasonWords = (code) => REASON_WORDS.get(code) || REASON_WORDS.get('no_lookup');
